@for (group of groupViews(); track $index; let groupFirst = $first) {
    <div [class]="group.className">
        @for (section of group.sections; track $index; let sectionFirst = $first) {
            <div
                appReveal
                [class]="section.className"
                [revealDisabled]="groupFirst && sectionFirst"
            >
                <span [appCmsStyles]="section.styles"></span>
                <ng-container
                    *ngComponentOutlet="section.component; inputs: section.inputs"
                />
            </div>
        }
    </div>
}
